import { IGetterFn } from '@/store/types';

/**
 * 验收列表的 tab 页签
 * 除了 `text` 字段外，其他字段都是搜索接口需要的字段，用于搜索
 * 如果不要 statuses, 则会查询所有状态[1,2,3,4]，全部里面是要排除掉状态4的
 * @property {string} text - tab页签上显示的文本
 * @property {number} status - 验收状态
 */
export const tabItems: IGetterFn = () => {
  return [
    { text: '全部', statuses: [1, 2, 3] },
    { text: '验收中', statuses: [1] },
    { text: '验收终止', statuses: [2] },
    { text: '验收完成', statuses: [3] },
  ];
};
